import { createContext, useContext, useEffect, useState } from "react";
import {
  getCurrentLanguage,
  getSupportedLanguages,
  setCurrentLanguage,
} from "../utils/i18n";

const LanguageContext = createContext();

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error(
      "useLanguageContext must be used within a LanguageProvider"
    );
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLang] = useState(getCurrentLanguage());

  const changeLanguage = (lang) => {
    if (getSupportedLanguages().includes(lang)) {
      setCurrentLanguage(lang);
      setCurrentLang(lang);
    }
  };

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
    };

    window.addEventListener("languageChanged", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChanged", handleLanguageChange);
  }, []);

  const value = {
    currentLanguage,
    changeLanguage,
    supportedLanguages: getSupportedLanguages(),
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
